import React from 'react';
import QuerySelectorComponent from "./QuerySelectorComponent";
import QuestionSelectorComponent from "./QuestionSelectorComponent";

const QAListComponent = (props) => {
    let data = (props.pageData && props.pageData.data) ? props.pageData.data : {};
    
    return (
        
            <div className="queryListDiv text-left">
              {/*   <span className={(!props.backBtn) ? 'd-none' : 'previous link'} onClick={props.preQuestion}>{data && data.backBtn ? data.backBtn : ''} </span> */}

                <h3 className={(props.backBtn) ? 'd-none' : ' text-left page-title'}>{data && data.pageTitle ? data.pageTitle : ''}</h3>

                {props.questionList ?
                    <>
                         {(!props.backBtn) ?   <QuerySelectorComponent nextQuestion={props.nextQuestion}  questions={props.questionList.questions} queryHeading={data && data.enquiryHeading ? data.enquiryHeading : ''} />  : <QuestionSelectorComponent nextQuestion={props.nextQuestion} questions={props.questionList} /> }                            
                        
                    </> : ''}
            </div>
         
    );
};

export default QAListComponent;